module.exports = __webpack_public_path__ + "static/media/Ashabul.c2924927.jpg";